<template>
  <div>
    Hello World!
  </div>
</template>

<script>
export default {
  name: 'Index'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/AppIndex.vue